import React, { useContext, useEffect, useState } from "react";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import lywoSymbl from "../assets/images/lywoSymbl.svg";
import LYWOLogo from "../assets/images/LYWOlogo.svg";
import FemaleHr from "../assets/images/FemaleHr.svg";
import "../../src/assets/style/lywocode.css"
import arrowRight from "../assets/images/arrow-right.svg";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { postWithAuthCallWithErrorResponse } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateData } from "../redux/roundtoSlice";
import { AppContext } from "../contaxt/AppContext";
import CustomButton from "../components/customButton";

const Lywocode = () => {
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [params] = useSearchParams()
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const { setUniqueCode, setIsNormal, setUserlgin } = useContext(AppContext)

  const [isCalled, setIsCalled] = useState(false)



  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value.toUpperCase());

    // Clear error when user starts typing
    if (errorMessage) {
      setErrorMessage('');
    }
  };



  const handleSubmit = (code = '', fromLink = false) => {
    const trimmedCode = inputValue.trim();

    if (!code.length && trimmedCode?.length != 7) {
      setErrorMessage('Please Enter valid 7 Words Code');

      return
    }

    localStorage.setItem('Uniquecode', trimmedCode || code)


    if (isCalled) return

    setIsCalled(true)

    postWithAuthCallWithErrorResponse(ApiConfig.LOGIN_WITH_UNIQUE_CODE, JSON.stringify({
      jobUniqueModel: trimmedCode || code,
    })).then((res) => {

      if (res?.json?.succeded) {



        let data = res?.json?.response[0]
        dispatch(updateData({ field: 'code', value: trimmedCode || code }))
        dispatch(updateData({ field: 'id', value: data?.id }))
        dispatch(updateData({ field: 'aboutJob', value: data?.aboutJob }))
        dispatch(updateData({ field: 'userId', value: data?.userId }))
        dispatch(updateData({ field: 'aboutCompany', value: data?.aboutCompany }))
        dispatch(updateData({ field: 'applicationType', value: data?.reason }))
        dispatch(updateData({ field: 'companyname', value: data?.company }))
        dispatch(updateData({ field: 'companyLogo', value: data?.companyLogo }))
        dispatch(updateData({ field: 'position', value: data?.position }))
        dispatch(updateData({ field: 'addInfoOne', value: data?.addInfoOne }))
        dispatch(updateData({ field: 'addInfoTwo', value: data?.addInfoTwo }))
        dispatch(updateData({ field: 'isNormalAssesment', value: data?.isNormalAssesment }))

        toast.success(res?.json?.response[0]?.message)
        setIsNormal(data?.isNormalAssesment)
        setUniqueCode(trimmedCode || code)


        navigate('/JobApplicationProcess');

      } else {
        dispatch(updateData({ field: 'code', value: trimmedCode || code }))
        setErrorMessage(res?.json?.response[0]?.message);

        if (res?.json?.response[0]?.position) {
          dispatch(updateData({ field: 'position', value: res?.json?.response[0]?.position }))
          dispatch(updateData({ field: 'type', value: 'InActiveCode' }))
          navigate('/InActiveJobCode')
        }


        toast.error(res?.json?.response[0]?.message)
      }
      setIsCalled(false)
    })


  };

  useEffect(() => {

    let code = params.get('code')


    if (code) {
      setUserlgin(true)
      setInputValue(code)
      handleSubmit(code, true)
    }

  }, [])


  return (
    <>
      <div className="clWrap">
        <div className="col-12 col-sm-4 col-md-3 codLogLftBg">
          <div className="codLogLftLogo">
            <img src={lywoSymbl} className="" alt="Logo" />
          </div>

          <div className="hrImgWrap">
            <img src={FemaleHr} className="hrImg" alt="Logo" />
          </div>
        </div>

        <div className="col-12 col-sm-8 col-md-9">
          <div className="codLoGSpc">
            <div className="codLoGWrap">
              <div className="codLoGInnrBox">
                <div className="lablInptBtn">
                  <h3>Get Started</h3>
                  <h4>Enter your code to begin your application</h4>
                  <input
                    type="text"
                    placeholder="Enter the code"
                    className="inputjobcode"
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                  />
                  {errorMessage && (
                    <p style={{ color: '#fb7185', textAlign: "start", marginTop: "10px", marginBottom: "0px" }}>{errorMessage}</p>
                  )}
                  <div className="btnAreaLogn">
                    <CustomButton
                      title=" Let’s Start"
                      className="loGinBtN"
                      handleClick={handleSubmit}
                      isIcon={true}
                      src={arrowRight}
                      isLoading={isCalled}
                    />
                    {/* <button
                      className="loGinBtN"
                      onClick={handleSubmit}>
                      Let’s Start
                      <img
                        src={arrowRight}
                        className="arrowIconStyl"
                        alt="ArrowRight-Icon"
                      />
                    </button> */}
                  </div>
                </div>
              </div>
              <p>This application Process is Managed by <span>LYWO</span></p>
            </div>
          </div>
        </div>
        <div className="hrImgWrapMob">
          <img src={FemaleHr} className="hrImg" alt="Logo" />
        </div>
      </div>
    </>

  );
};

export default Lywocode;